const validatedFieldMixin = {
  created() {
    if (this.validator) {
      if (this.validator.handledFields === undefined) {
        this.validator.handledFields = new Set();
      }
      this.validator.handledFields.add(this.field);
    }
  },
  data() {
    return {
      hasChanged: false,
      shouldDelayValidationUntilFirstChange: true,
      hasErrors: false,
      schemaKey: this.field.replace(/\.\d+\./g, '.$.'),
    };
  },
  computed: {
    computedLabel() {
      return this.validator._simpleSchema.label(this.schemaKey);
    },
    computedRequired() {
      if (this.validator) {
        return !this.validator._simpleSchema.get(this.schemaKey, 'optional');
      }
    },
    error() {
      if (!this.validator) {
        return [];
      }
      if (!this.hasErrors) {
        return;
      }
      const error = this.validator
        .validationErrors()
        .find((error) => error.name === this.field);
      if (!error) {
        return;
      }
      return error.message
        ? error.message
        : this.validator.keyErrorMessage(error.name);
    },
  },
  methods: {
    markAsChanged() {
      this.hasChanged = true;
      this.validate();
    },
    validate() {
      if (this.shouldDelayValidationUntilFirstChange && !this.hasChanged) {
        return;
      }
      const data = this.createDataObject(this.field, this.value);
      this.hasErrors = !this.validator.validate(this.validator.clean(data), {
        keys: [this.field],
      });
    },
    createDataObject(field, value) {
      /**
       * split the field on the dots (e.g. file.owner._id)
       * then reverse the array
       * finally reduce the array constructing an object like so:
       * { file: { owner: { _id: value } } }
       */
      return field
        .split('.')
        .reverse()
        .reduce((data, propName) => {
          return { [propName]: data };
        }, value);
    },
  },
  watch: {
    value() {
      this.validate();
    },
    'validator.validationTrigger'() {
      this.shouldDelayValidationUntilFirstChange = false;
      this.validate();
    },
  },
};

export default validatedFieldMixin;
